var render, staticRenderFns
import script from "./AxInput.vue?vue&type=script&lang=ts&"
export * from "./AxInput.vue?vue&type=script&lang=ts&"
import style0 from "./AxInput.vue?vue&type=style&index=0&id=36381dec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36381dec",
  null
  
)

export default component.exports